import Image from 'global/Image';
import { EmptyTableWrapper } from './styled';

interface IEmptyTable {
  text: string;
}

const EmptyTable = ({ text }: IEmptyTable) => (
  <EmptyTableWrapper>
    <Image src="/illustration/empty-table.svg" />
    <p>{text}</p>
  </EmptyTableWrapper>
);

export default EmptyTable;
